import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import { pageMobileCardSx } from "../../styles/pageModernStyles";

const chipAccent = (theme, chip) => {
  if (chip.color === "success") return theme.palette.success.main;
  if (chip.color === "warning") return theme.palette.warning.main;
  if (chip.color === "error") return theme.palette.error.main;
  if (chip.color === "info") return theme.palette.info.main;
  return theme.palette.primary.main;
};

const ExpenseUserNotesMobile = ({
  theme,
  rows,
  t,
  formatNoteDate,
  onOpen,
}) => {
  if (!rows.length) return null;

  return (
    <Stack spacing={1.25}>
      {rows.map((row) => {
        const chipAcc = row._chipAcc;
        const chipPay = row._chipPay;
        const accent = chipAccent(theme, chipAcc);
        const userLabel = row._userLabel;
        const desc = row.Description && String(row.Description).trim();

        return (
          <Box
            key={row.id}
            onClick={() => onOpen(row.id)}
            sx={{
              ...pageMobileCardSx(theme, { accentColor: accent }),
              pl: 2,
              cursor: "pointer",
              transition: "transform 0.15s ease, box-shadow 0.15s ease",
              "&:active": { transform: "scale(0.99)" },
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              gap={1}
            >
              <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1.5,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: alpha(accent, 0.12),
                    color: accent,
                  }}
                >
                  <ReceiptLongOutlinedIcon sx={{ fontSize: 18 }} />
                </Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 800, letterSpacing: 0.4, color: "text.secondary" }}
                >
                  #{row.id}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap justifyContent="flex-end">
                <Chip
                  size="small"
                  label={chipAcc.label}
                  color={chipAcc.color}
                  variant={chipAcc.variant}
                  sx={{ height: 22, fontWeight: 700, fontSize: "0.65rem" }}
                  onClick={(e) => e.stopPropagation()}
                />
                <Chip
                  size="small"
                  label={chipPay.label}
                  color={chipPay.color}
                  variant={chipPay.variant}
                  sx={{ height: 22, fontWeight: 700, fontSize: "0.65rem" }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Stack>
            </Stack>

            <Typography
              sx={{
                mt: 0.85,
                fontWeight: 800,
                fontSize: "0.95rem",
                lineHeight: 1.25,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {row.Title || t("ExpenseUser.noTitle")}
            </Typography>

            {desc ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mt: 0.5,
                  fontSize: "0.8rem",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {desc}
              </Typography>
            ) : null}

            <Stack
              direction="row"
              spacing={1.25}
              sx={{ mt: 1, flexWrap: "wrap" }}
              useFlexGap
            >
              <Stack direction="row" spacing={0.4} alignItems="center">
                <EventOutlinedIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                <Typography variant="caption" color="text.secondary" fontWeight={600}>
                  {formatNoteDate(row.createdAt)}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={0.4} alignItems="center" sx={{ minWidth: 0 }}>
                <PersonOutlineOutlinedIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={600}
                  noWrap
                >
                  {userLabel}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};

export default ExpenseUserNotesMobile;
